// This needs to be in global scope otherwise it wont work. I have no idea why not, it took too
// long to diagnose the issue to spend time trying to find out why.
if ($.validator && $.validator.unobtrusive) {

	// The validator:
	// - value is the value of the element to be validated
	// - element is the HTML element that the validator is attached to
	// - params is the array of name/value pairs of the parameters extracted from the HTML
	$.validator.addMethod("passwordpolicies", function (value, element, params) {

		var regex = params["regex"];
		var min = params["min"];
		var max = params["max"];

		if (value.length < min || value.length > max)
			return false;

		var pattern = new RegExp(regex);
		if (!pattern.test(value))
			return false;

		return true;
	});

	/* The adapter signature:
	$.validator.unobtrusive.adapters.add(adapterName, params, fn);

	- adapterName is the name of the adapter, and matches the name of the rule in the HTML element.
	- params is an array of parameter names that you're expecting in the HTML attributes, and is optional. If it is not provided,
	  then it is presumed that the validator has no parameters.
	- fn is a function which is called to adapt the HTML attribute values into jQuery Validate rules and messages.

	The function will receive a single parameter which is an options object with the following values in it:
	  element  - The HTML element that the validator is attached to
	  form     - The HTML form element
	  message  - The message string extract from the HTML attribute
	  params   - The array of name/value pairs of the parameters extracted from the HTML attributes
	  rules    - The jQuery rules array for this HTML element. The adapter is expected to add item(s) to this rules array for the specific jQuery Validate validators
				 that it wants to attach. The name is the name of the jQuery Validate rule, and the value is the parameter values for the jQuery Validate rule.
	  messages - The jQuery messages array for this HTML element. The adapter is expected to add item(s) to this messages array for the specific jQuery Validate validators that it wants to attach, if it wants a custom error message for this rule. The name is the name of the jQuery Validate rule, and the value is the custom message to be displayed when the rule is violated.
	*/
	$.validator.unobtrusive.adapters.add("passwordpolicies", ["regex", "min", "max"], function (options) {
		options.rules["passwordpolicies"] = {
			regex: options.params.regex,
			min: options.params.min,
			max: options.params.max
		};
		options.messages["passwordpolicies"] = options.message;
	});
} else {
	console.log('WARNING - The jquery validator hasn\'t yet been defined');
}
